import { Component, isDevMode } from '@angular/core';

import { CoreService } from '../../services/core.service';
import { UtilityService } from '../../../shared/services/utility.service';

@Component({
    selector: 'sign-up',
    templateUrl: './signup.component.html',
    styleUrls: ['./signup.component.css']
})
export class SignupComponent {
    name: string;
    email: string;
    password: string;
    password2: string;

    error: string;
    loading: boolean;

    constructor(private api: CoreService, private util: UtilityService) {

        util.setTitle("Signup");

        if (isDevMode()) {
            this.name = "ayman";
            this.email = "a@a.com";
            this.password = "ayman123";
            this.password2 = "ayman123";
        }
    }

    submit(): void {
        this.api.signup({
            name: this.name,
            email: this.email,
            password: this.password,
        }).subscribe((data: any) => {

            this.util.navigateToLoginPage();

        }, err => {
            this.error = err.error.message || err.error;
        });
    }
}
